export const classnames = (...classnames) =>
	classnames?.filter(Boolean).join(" ");
